import React, { useState, useEffect } from 'react'
import { useSearchParams} from "react-router-dom";

import { DataGrid } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import { Grid, Typography } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';

import DeleteNotification from '../../core/components/DeleteNotification';
import {CoreContext} from "../../core/context/CoreContext";
import PageWaiting from '../../core/components/PageWaiting';
import {isMobile} from 'react-device-detect';

import {getListAPI, deleteAPI} from './CompositiontemplateAPI';
import {getColumns} from './CompositiontemplateStruct';
import ListCardView from '../../core/components/card/ListCardView';
import ListTableView from '../../core/components/card/ListTableView';

import {getCompositiontemplateView} from './CompositiontemplateView';
import CardListLayout from '../../core/components/card/layout/CardListLayout';
import { useSelector, useDispatch } from 'react-redux';
import {setViewParams} from '../../store/slice/ChoiceSelectionSlice';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import CalendarViewMonthIcon from '@mui/icons-material/CalendarViewMonth';

import {setFilter} from '../../store/slice/ConfSlice';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import MyPageContainer from '../../core/template/MyPageContainer';
import { deleteCompositiontemplateObj  ,setSelectedCompositiontemplateId,setCompositiontemplateCompositionMgmtModal,setSelectedActionId , setShowEditForCompositiontemplate} from 'store/slice/PharmaSlice';

import CompositiontemplateListTable from './components/CompositiontemplateListTable';
import { useNavigate } from "react-router-dom";
import { setClickedBo,setActionClicked } from 'store/slice/BreadCrumSlice';
import CompositiontemplateFilterCriteria from './CompositiontemplateFilterCriteria';


import SettingsInputComponentIcon from '@mui/icons-material/SettingsInputComponent';

import CompositionMgmtActionModal from './action/compositionMgmt/CompositionMgmtActionModal';

import { transformDateValue } from 'core/js/FormUtils';

export default function CompositiontemplateList( {tableList, cardList, setShowEdit, setCompositiontemplateId}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setNotification, setShowLoading, showloading, lastURL } = React.useContext(CoreContext);
  const columns = getColumns(editCallBack, initDeleteCallBack);
  const [view, setView] = useState(1);
  const { showfilter } = useSelector((state) => state.confslice)

  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const {selectedId, compositiontemplateObj} = useSelector((state)=>state.pharmaslice.compositiontemplateDashboard);
  const { compositiontemplateList } = useSelector((state) => state.pharmaslice.compositiontemplateDashboard);

  useEffect(() => {
  }, [compositiontemplateList, compositiontemplateObj])
  
  function initDeleteCallBack(id){
    dispatch(setSelectedCompositiontemplateId(id));
    setShowDeleteAlert(true);
  }
  function deleteCallBack(obj){
    dispatch(deleteCompositiontemplateObj(obj.id));
    setNotification('Record deleted successfully !!!')
  }
  function deleteRecord(){
    deleteAPI(selectedId,deleteCallBack);
    setShowDeleteAlert(false);
  }

  function editCallBack(id){
    dispatch(setSelectedCompositiontemplateId(id));
    dispatch(setShowEditForCompositiontemplate(true));
  }
  
  const createCompositiontemplate=()=>{
    dispatch(setSelectedCompositiontemplateId(-1));
    dispatch(setShowEditForCompositiontemplate(true));
  }


  const compositionMgmtCallBack = (id) =>{
    dispatch(setSelectedCompositiontemplateId(id));
    dispatch(setCompositiontemplateCompositionMgmtModal(true));
  }

const getDataWithDateTransformation = (data) =>{
    let newData = {
      ...data,
      'expand':false,

    }
    return newData;
  }
  const compositiontemplateTransformation = (tableList) =>{
    let newDataList=[]
    tableList.map((data)=>{ 
      newDataList.push(getDataWithDateTransformation(data));
     })
    return newDataList;
  }

  const payload = {
    compositiontemplateList:compositiontemplateList,
    cardList:getCompositiontemplateView(tableList),
        actionList: [
          /*{title:'Edit', callBackMethod:editCallBack, icon:<EditIcon/>, status:'NA'},
          {title:'Delete', callBackMethod:initDeleteCallBack, icon:<DeleteIcon/>, status:'NA'},
          
        {id:42, title:'Manage Composition', callBackMethod:compositionMgmtCallBack, icon:<SettingsInputComponentIcon/>, status:'Draft', role:''},
        */
        ],
        dialogueActionList: [
          
        ],
    tableView:{
      tableList:compositiontemplateTransformation(tableList),
      compositiontemplateList:compositiontemplateList,
      actionList:[
        {title:'Edit', callBackMethod:editCallBack, icon:<EditIcon/>, status:'NA'},
        {title:'Delete', callBackMethod:initDeleteCallBack, icon:<DeleteIcon/>, status:'NA'},
        
        {id:42, title:'Manage Composition', callBackMethod:compositionMgmtCallBack, icon:<SettingsInputComponentIcon/>, status:'Draft', role:''},
      ]
    }
  }
  
  const getPayload = ()=>{
    return payload;
  }

  useEffect(()=>{
    if (document.body.offsetWidth<500)  setView(0);
    dispatch(setViewParams({
      colsCount:{xs:12, sm:4, md:4, lg:4},
      modal:{
            
      }
      }))
  },[])

  return (
   <>
   {showloading?<PageWaiting/>:
      <Grid container direction="column">
              <Grid item>
                  <Grid container direction="row" justifyContent={'space-between'} alignContent={'center'} sx={{height:showfilter?'55px':'35px'}}>
                      <Grid item  lg={3}>
                        <Typography variant='h4' color="primary.darker">Composition Template</Typography>
                      </Grid>
                      <Grid item lg={8}>
                      {showfilter ?  < CompositiontemplateFilterCriteria  />: <></>}
                      </Grid>
                      <Grid item lg={1}>
                        <Grid container justifyContent={'flex-end'}>
                        {showfilter?
                            <Grid item>
                              <Tooltip title="Hide filter" sx={{cursor: "pointer"}}>
                                <FilterAltOffIcon onClick={()=>{dispatch(setFilter(false))}}/>
                              </Tooltip>
                            </Grid>
                            :
                            <Grid item>
                              <Tooltip title="Show filter" sx={{cursor: "pointer"}}>
                                <FilterAltIcon onClick={()=>{dispatch(setFilter(true))}}/>
                              </Tooltip>
                            </Grid>
                            }
                            {/*view===1?
                            <Grid item>
                              <Tooltip title="Grid View" sx={{cursor: "pointer"}}>
                                <ViewWeekIcon onClick={()=>{setView(0)}}/>
                              </Tooltip>
                            </Grid>
                            :
                            <Grid item>
                              <Tooltip title="Table View" sx={{cursor: "pointer"}}>
                                <CalendarViewMonthIcon onClick={()=>{setView(1)}}/>
                              </Tooltip>
                            </Grid>
                            */}
                            <Grid item>
                              <Tooltip title="Add Compositiontemplate" sx={{cursor: "pointer"}}>
                                <AddIcon onClick={()=>{createCompositiontemplate()}}/>
                              </Tooltip>
                            </Grid>
                          </Grid>
                      </Grid>
                      
                  </Grid>
              </Grid>
              <Grid item>
                < CompositiontemplateListTable 
                  payload={getPayload().tableView}
                  />
                  
              </Grid>     
      </Grid>
   }
    { showDeleteAlert?<DeleteNotification 
            id={selectedId}
            width="50%"
            setShowDeleteAlert={setShowDeleteAlert}
            deleteRecord = {deleteRecord}/>: ''
    }

    
<CompositionMgmtActionModal/>
    </>
);


}